import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import SpinCustom from '@/components/common/Spin';
import LegacyRequestRedirect from '@/pages/ADMIN/RequestManagement/components/RequestRouteEntry/LegacyRedirect';
import { LEGACY_REQUEST_ROUTES } from '@/lib/request-routing';
import ROUTER from './ROUTER';
const PqrStandards = React.lazy(() => import('@/pages/ADMIN/PqrStandards'));

const routerDetail = (route: string) => `${route}/:id`;
const routerCreate = (route: string) => `${route}/create`;
const routerUpdate = (route: string) => `${route}/:id/update`;
const routerCreateTab = (route: string) => `${route}/:id/create-tab`;

// common
const PublicRouters = React.lazy(
  () => import('@/pages/SUPPORTPAGES/PublicRouters'),
);
const SvgViewer = React.lazy(() => import('src/pages/SUPPORTPAGES/SvgViewer'));
const NotFound = React.lazy(() => import('@/pages/SUPPORTPAGES/NotFound'));
const Home = React.lazy(() => import('@/pages/ANONYMOUS/Home/Home'));
const UploadFilePage = React.lazy(
  () => import('@/pages/ANONYMOUS/UploadFilePage'),
);

const PrivateRoutes = React.lazy(
  () => import('@/pages/SUPPORTPAGES/PrivateRoutes'),
);
const AminRoutes = React.lazy(() => import('@/pages/SUPPORTPAGES/AminRoutes'));
// ANONYMOUS

// USER

const MyAccount = React.lazy(() => import('@/pages/USER/MyAccount'));
// ADMIN
const DashBoard = React.lazy(() => import('@/pages/ADMIN/DashBoard'));
const EmailManagement = React.lazy(
  () => import('@/pages/ADMIN/EmailManagement'),
);
const RoleManagement = React.lazy(() => import('@/pages/ADMIN/RoleManagement'));
const UserManagement = React.lazy(() => import('@/pages/ADMIN/UserManagement'));
const ProfileManagement = React.lazy(
  () => import('@/pages/ADMIN/ProfileManagement'),
);
const TicketManagement = React.lazy(
  () => import('@/pages/ADMIN/WorkingDay/TicketManagement'),
);
const MyTicket = React.lazy(() => import('@/pages/ADMIN/WorkingDay/MyTicket'));
// const EmployeeAttendance = React.lazy(
//   () =>
//     import(
//       '@/pages/ADMIN/WorkingDay/AttendanceSheet/modal/DetailDrawer/components/EmployeeAttendance'
//     ),
// );
const AttendancSheet = React.lazy(
  () => import('@/pages/ADMIN/WorkingDay/AttendanceSheet'),
);
const EmployeeAttendancSheet = React.lazy(
  () => import('@/pages/ADMIN/WorkingDay/EmployeeAttendancSheet'),
);

//Customers
const CustomerManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/CustomerManagement'),
);
const CustomerDetail = React.lazy(
  () =>
    import(
      '@/pages/ADMIN/Customers/CustomerManagement/modules/CustomerDetailTab'
    ),
);
const WelderManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/Weldermanagement'),
);
const RequestConfigHardness = React.lazy(
  () => import('@/pages/ADMIN/RequestConfigHardness'),
);

const PaymentManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/PaymentManagement'),
);
const QuotationManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/QuotationManagement'),
);
const PaymentDocumentManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/PaymentDocumentManagement'),
);
const ContractManagement = React.lazy(
  () => import('@/pages/ADMIN/Customers/ContractManagement'),
);

// ================
// Devices

const EquipmentToolsManagement = React.lazy(
  () => import('@/pages/ADMIN/Devices/Testingequipment'),
);
const CalibrationEquipmentManagement = React.lazy(
  () => import('@/pages/ADMIN/Devices/Machining equipment'),
);
const EquipmentMaterialsManagement = React.lazy(
  () => import('@/pages/ADMIN/Devices/Office equipment'),
);
// ================
const ProcessInstructionManagement = React.lazy(
  () => import('@/pages/ADMIN/ProcessInstructionManagement'),
);
const SubcontractorManagement = React.lazy(
  () => import('@/pages/ADMIN/SubcontractorManagement'),
);
const ProposalManagement = React.lazy(
  () => import('@/pages/ADMIN/ProposalManagement'),
);

const TodoList = React.lazy(() => import('@/pages/ADMIN/TodoList'));
const Schedule = React.lazy(() => import('@/pages/ADMIN/Schedule'));
// const ColumnManagement = React.lazy(
//   () => import('@/pages/ADMIN/TaskManagement/ColumnManagement'),
// );
const FileManagement = React.lazy(() => import('@/pages/ADMIN/FileManagement'));

const ProfileDetail = React.lazy(
  () => import('@/pages/ADMIN/ProfileManagement/components/ProfileDetail'),
);

const RequestListEntry = React.lazy(
  () =>
    import(
      '@/pages/ADMIN/RequestManagement/components/RequestRouteEntry/ListEntry'
    ),
);
const RequestRouteEntry = React.lazy(
  () => import('@/pages/ADMIN/RequestManagement/components/RequestRouteEntry'),
);
const CreateRequestEntry = React.lazy(
  () => import('@/pages/ADMIN/RequestManagement/components/CreateRequestEntry'),
);
const MasterList = React.lazy(() => import('@/pages/ADMIN/MasterList'));

function LazyLoadingComponent({ ...rest }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: '100vh' }}>
          <SpinCustom fullscreen />
        </div>
      }
    >
      {rest.children}
    </React.Suspense>
  );
}
const requestRoutesMerged = [
  {
    path: ROUTER.REQUEST_MANAGEMENT,
    element: (
      <LazyLoadingComponent>
        <RequestListEntry />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.REQUEST_MANAGEMENT_DETAIL,
    element: (
      <LazyLoadingComponent>
        <RequestRouteEntry action="detail" />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.REQUEST_MANAGEMENT_UPDATE,
    element: (
      <LazyLoadingComponent>
        <RequestRouteEntry action="update" />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.REQUEST_MANAGEMENT_CREATE_TAB,
    element: (
      <LazyLoadingComponent>
        <RequestRouteEntry action="create-tab" />
      </LazyLoadingComponent>
    ),
  },
];

const legacyRequestRoutes = [
  ...LEGACY_REQUEST_ROUTES,
  {
    path: ROUTER.REQUEST_MANAGEMENT_VUNG_TAU,
    requestType: undefined,
    agent: 'VT' as const,
  },
];
const requestRoutes = legacyRequestRoutes.flatMap(
  ({ requestType, agent, path }) => [
    {
      path,
      element: (
        <LegacyRequestRedirect
          action="list"
          requestType={requestType}
          agent={agent}
        />
      ),
    },
    {
      path: routerDetail(path),
      element: <LegacyRequestRedirect action="detail" agent={agent} />,
    },
    {
      path: routerCreate(path),
      element: (
        <LegacyRequestRedirect
          action="create"
          requestType={requestType ?? 'TEST_MATERIAL'}
          agent={agent}
        />
      ),
    },
    {
      path: routerUpdate(path),
      element: <LegacyRequestRedirect action="update" agent={agent} />,
    },
    {
      path: routerCreateTab(path),
      element: <LegacyRequestRedirect action="create-tab" agent={agent} />,
    },
  ],
);
export const requestManagementRoutes = [
  ...requestRoutesMerged,
  ...requestRoutes,
  {
    path: ROUTER.REQUEST_MANAGEMENT_CREATE,
    element: (
      <LazyLoadingComponent>
        <CreateRequestEntry />
      </LazyLoadingComponent>
    ),
  },
];
const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DASHBOARD,
        element: (
          <LazyLoadingComponent>
            <DashBoard />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.EMAIL_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <EmailManagement />
          </LazyLoadingComponent>
        ),
      },
      //Request
      ...requestManagementRoutes,
      {
        path: ROUTER.MASTER_LIST,
        element: (
          <LazyLoadingComponent>
            <MasterList />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.USER_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <UserManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PROFILE_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <ProfileManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PROFILE_MANAGEMENT + '/:id',
        element: (
          <LazyLoadingComponent>
            <ProfileDetail />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.CUSTOMER_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <CustomerManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.WELDER_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <WelderManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PAYMENT_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <PaymentManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TICKET_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <TicketManagement />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.MY_TICKET,
        element: (
          <LazyLoadingComponent>
            <MyTicket />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.PQR_STANDARDS,
        element: <LazyLoadingComponent><PqrStandards /></LazyLoadingComponent>,
      },
      {
        path: ROUTER.REQUEST_CONFIG,
        element: (
          <LazyLoadingComponent>
            <RequestConfigHardness />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.LEGACY_REQUEST_CONFIG,
        element: <Navigate to={ROUTER.REQUEST_CONFIG} replace />,
      },
      // {
      //   path: ROUTER.EMPLOYEE_ATTENDANCE,
      //   element: (
      //     <LazyLoadingComponent>
      //       <EmployeeAttendance />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.ATTENDANC_SHEET,
        element: (
          <LazyLoadingComponent>
            <AttendancSheet />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.EMPLOYEE_ATTENDANC_SHEET,
        element: (
          <LazyLoadingComponent>
            <EmployeeAttendancSheet />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.QUOTATION_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <QuotationManagement />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.PAYMENT_DOCUMENT_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <PaymentDocumentManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CONTRACT_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <ContractManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.EQUIPMENT_TOOLS_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <EquipmentToolsManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.CALIBRATION_EQUIPMENT_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <CalibrationEquipmentManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.EQUIPMENT_AND_MATERIALS_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <EquipmentMaterialsManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PROCESS_INSSTRUCTION_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <ProcessInstructionManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.Schedule,
        element: (
          <LazyLoadingComponent>
            <Schedule />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.Schedule_BIEN_HOA,
        element: (
          <LazyLoadingComponent>
            <Schedule />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.TO_DO_LIST,
        element: (
          <LazyLoadingComponent>
            <TodoList />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TO_DO_LIST_BIEN_HOA,
        element: (
          <LazyLoadingComponent>
            <TodoList />
          </LazyLoadingComponent>
        ),
      },

      // {
      //   path: ROUTER.COLUMN_MANAGEMENT,
      //   element: (
      //     <LazyLoadingComponent>
      //       <ColumnManagement />
      //     </LazyLoadingComponent>
      //   ),
      // },
      {
        path: ROUTER.SUBCONTRACTOR_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <SubcontractorManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PROPOSAL_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <ProposalManagement />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.CUSTOMER_MANAGEMENT_DETAIL + '/:id',
        element: (
          <LazyLoadingComponent>
            <CustomerDetail />
          </LazyLoadingComponent>
        ),
      },

      {
        path: ROUTER.FILE_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <FileManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.FILE_MANAGEMENT + '/:documentId',
        element: (
          <LazyLoadingComponent>
            <FileManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ROLE_MANAGEMENT,
        element: (
          <LazyLoadingComponent>
            <RoleManagement />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.THONG_TIN_TAI_KHOAN,
        element: (
          <LazyLoadingComponent>
            <MyAccount />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [],
  },
  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DEFAULT,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.UPLOADFILE,
        element: (
          <LazyLoadingComponent>
            <UploadFilePage />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: '*',
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
];
const AppRouter = () => {
  const renderRouter = useRoutes(routes);
  return renderRouter;
};
export default AppRouter;
